import { Children, isValidElement, useEffect } from 'react';
import type React from 'react';

import type { FloatingContext } from '@floating-ui/react';

import logger from 'js/app/loggerSingleton';

import { ARROW_WIDTH } from 'bundles/common/components/Tooltip/constants';
import type { Placement } from 'bundles/common/components/Tooltip/types';

export const getOnlyChild = (children: React.ReactNode): JSX.Element | undefined => {
  try {
    const child = Children.only(children);
    return isValidElement(child) ? child : undefined;
  } catch (err) {
    logger.error(err);
    return undefined;
  }
};

type Options = {
  enabled: boolean;
};

export const useDismissOnResize = (
  { open, onOpenChange }: FloatingContext,
  { enabled }: Options = { enabled: true }
) => {
  useEffect(() => {
    const handleResize = () => onOpenChange(false);

    if (open && enabled) {
      window.addEventListener('resize', handleResize);
    }

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [open, enabled, onOpenChange]);
};

export const getArrowOffset = (placement: Placement) => {
  switch (placement) {
    case 'top':
    case 'bottom':
      return { x: `calc(50% - ${ARROW_WIDTH / 2}px)`, centerOffset: 0 };

    case 'left':
    case 'right':
      return { y: `calc(50% - ${ARROW_WIDTH / 2}px)`, centerOffset: 0 };

    default:
      return { x: 0, y: 0, centerOffset: 0 };
  }
};
